import { defineMessages, useIntl } from 'react-intl';

import {
  TextInput,
  type TextInputProps,
} from '../Editors/FlowEditor/FlowEditor';
import { BlockLabel } from './BlockLabel';

const messages = defineMessages({
  placeholder: {
    defaultMessage: 'Add a description (optional)',
    id: 'JcefuP',
  },
  label: {
    defaultMessage: 'Description (optional)',
    id: 'bZenNC',
  },
});

type BlockDescriptionProps = Pick<TextInputProps, 'onChange' | 'value'>;

export function BlockDescription({ onChange, value }: BlockDescriptionProps) {
  const { formatMessage } = useIntl();

  return (
    <div className="flex flex-col gap-1">
      <BlockLabel>{formatMessage(messages.label)}</BlockLabel>
      <TextInput
        onChange={onChange}
        placeholder={formatMessage(messages.placeholder)}
        value={value}
      />
    </div>
  );
}
